<template lang="pug">
  .card-info
    cp-icon.card-info__icon(v-if="iconName" :path="`/icons/${iconName}.svg`")
    p.card-info__text(v-html="text")
</template>
<script>
import cpIcon from '@/components/atoms/Icon.vue'

export default {
  name: 'CardInfo',
  props: {
    iconName: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: null
    }
  },
  components: {
    cpIcon
  }
}
</script>
<style lang="scss" scoped>
  @import "@/assets/style/_variables";

  .card-info {
    align-items: center;
    background-color: #F5F7FA;
    border-radius: 8px;
    display: flex;
    margin-top: 24px;
    padding: 12px 15px;

    &__icon {
      height: 24px;
      margin-right: 16px;
      width: 24px;
    }

    &__text {
      font-family: $rubik-font-family;
      font-size: 14px;
      color: #444444;
    }
  }
</style>
